<script lang="ts">
  import type { Snippet } from "svelte";
  import Parasol from "./brand/Parasol.svelte";

  interface Props {
    filterName?: string;
    title?: string;
    description?: string | Snippet;
    action?: Snippet;
    fullHeight?: boolean;
    class?: string;
  }

  let {
    filterName,
    title = "No results found",
    description,
    action,
    fullHeight = false,
    class: className,
  }: Props = $props();
</script>

<div
  class={[
    "flex w-full flex-col items-center justify-center gap-4 rounded-xl border border-alpha-050 bg-mono-200",
    fullHeight ? "h-full" : "h-[320px]",
    className,
  ]}
>
  <div
    class="shadow-with-inset flex h-8 w-8 items-center justify-center rounded-full bg-mono-100 shadow-border-inset"
  >
    <span class="animate-parasol-shake">
      <Parasol class="text-foreground-tertiary" size={16} />
    </span>
  </div>
  <div class="flex flex-col items-center justify-center gap-1">
    <p class="text-sm text-foreground-primary">
      {filterName ? `No results found with name "${filterName}" found.` : title}
    </p>
    {#if description}
      <p class="text-center text-sm text-foreground-tertiary">
        {#if typeof description === "string"}
          {description}
        {:else}
          {@render description()}
        {/if}
      </p>
    {/if}
  </div>
  {#if action}
    {@render action()}
  {/if}
</div>

<style>
  @reference "#tailwind.css";
  @keyframes parasol-shake {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(-15deg);
    }
    20% {
      transform: rotate(15deg);
    }
    30% {
      transform: rotate(-15deg);
    }
    40% {
      transform: rotate(15deg);
    }
    50% {
      transform: rotate(-15deg);
    }
    60% {
      transform: rotate(15deg);
    }
    70% {
      transform: rotate(-15deg);
    }
    80% {
      transform: rotate(15deg);
    }
    90% {
      transform: rotate(-15deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  :global(.animate-parasol-shake) {
    animation: parasol-shake 1.5s ease-in-out;
  }
</style>
